/**
 * Stores where the customer timeline is hidden for style-advisors.
 * Matched against the physical `locationCode` (not sale-location id).
 */
export const TIMELINE_HIDDEN_LOCATION_CODES = [
  'SR-CN-Beijing-ParkViewGreen',
  'SR-CN-Chongqing-Mixc',
  'SR-CN-Hangzhou-KerryCentre',
  'SR-HK-HongKong-Central',
  'SR-CN-Shanghai-Anfu',
  'SR-CN-Shanghai-Pudong',
  'SR-CN-Shenyang-Mixc',
  'SR-CN-Shenzhen-MixcBay',
] as const

const TIMELINE_HIDDEN_LOCATION_CODE_SET = new Set<string>(
  TIMELINE_HIDDEN_LOCATION_CODES,
)

/**
 * Whether the customer timeline should be hidden for this store location.
 * Synchronous — no GrowthBook fetch — so the overview tab never flashes the
 * timeline before the exclusion list is known.
 */
export function isCustomerTimelineHidden(locationCode: string): boolean {
  const normalized = locationCode.trim()
  if (!normalized) return false
  return TIMELINE_HIDDEN_LOCATION_CODE_SET.has(normalized)
}
